<template>
  <div
    v-if="prospectStage && prospectStage.id && prospectStage.instructions"
    class="overflow-y-auto"
    :style="{ height: 'calc(100vh - 4.5rem - 8rem - 3.5rem)' }"
  >
    <div
      v-if="!prospectStage.instructions.length"
      class="h-full grid items-center justify-center"
    >
      <BlTextBody2 text="There are no instructions for this stage." />
    </div>
    <div v-else-if="prospectStage.instructions.length" class="py-5 px-6 flex flex-col gap-2">
      <InstructionProspect
        v-for="instruction in prospectStage.instructions"
        :key="instruction.id"
        :instruction="instruction"
        editable
      />
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from "vuex";

import InstructionProspect from "./InstructionProspect.vue";

import BlTextBody2 from "../../../BlTextBody2.vue";
import BlIcon from "../../../BlIcon.vue";
import BlBubbleCount from "../../../BlBubbleCount.vue";
import BlFileHolder from "../../../BlFileHolder.vue";

export default {
  name: "StageInstructionTab",
  components: {
    InstructionProspect,
    BlTextBody2,
    BlIcon,
    BlBubbleCount,
    BlFileHolder
  },
  props: {},
  data() {
    return {};
  },
  computed: {
    ...mapGetters(["currentUser", "prospectStage"])
  },
  watch: {},
  mounted() {},
  methods: {
    ...mapActions([""])
  }
};
</script>



// WEBPACK FOOTER //
// src/components/salesPipeline/modal/prospectPanel/StageInstructionTab.vue